<form class="ui form" #form="ngForm">
    <ng-container *ngIf="review">
        <app-segment-header title="Review details"></app-segment-header>
        <div class="four fields">
            <div class="field">
                <label class="font-medium">Review Name</label>
                <div>{{ review.title }}</div>
            </div>
            <div class="field">
                <label class="font-medium">Reviewee</label>
                <div>{{ review?.subject?.firstName }} {{ review?.subject?.lastName }}</div>
            </div>
        </div>

        <div class="four fields margin-bottom-3">
            <div class="field">
                <label class="font-medium">Frequency</label>
                <div>{{ review.reoccuring }}</div>
            </div>
            <div class="field">
                <label class="font-medium">Access</label>
                <div>{{ review.getResponseAccessMessage() }}</div>
            </div>
        </div>

        <mat-divider></mat-divider>

        <app-segment-header class="margin-top-3" title="Schedule"></app-segment-header>
        <div class="four fields">
            <div class="field">
                <label class="font-medium">Review Date</label>
                <div>{{ review.scheduleAt | appDate: 'yyyy-MM-dd' }}</div>
            </div>

            <div class="field">
                <label class="font-medium">Due Date</label>
                <div>{{ review.dueAt | appDate: 'yyyy-MM-dd' }}</div>
            </div>
        </div>

        <mat-divider></mat-divider>

        <app-segment-header class="margin-top-3" title="Review Period"></app-segment-header>
        <div class="four fields margin-bottom-3">
            <div class="field">
                <label class="font-medium">Period Start Date</label>
                <div>{{ review.periodStart | appDate: 'yyyy-MM-dd' }}</div>
            </div>

            <div class="field">
                <label class="font-medium">Period End Date</label>
                <div>{{ review.periodEnd | appDate: 'yyyy-MM-dd' }}</div>
            </div>
        </div>

        <mat-divider></mat-divider>

        <app-segment-header class="margin-top-3" title="Participants"></app-segment-header>
        <div class="four fields">
            <div class="field">
                <label class="font-medium">Employees Selected</label>
                <div>{{ getParticipantCount() }}</div>
            </div>
        </div>
    </ng-container>
</form>
